import { faUser,
    faUnlockAlt,
    faExclamationTriangle,
    faEnvelope,
    faCheckCircle as faCheckCircleSolid,
    faCheck,
    faCircle as faCircleSolid } from '@fortawesome/free-solid-svg-icons';

const loginViewFontIcons = [faUser, faUnlockAlt, faExclamationTriangle, faEnvelope, faCheckCircleSolid, faCheck, faCircleSolid];

export default loginViewFontIcons;